export enum WelcomeBonusStatusesEnum {
    NOT_CLAIM = 'NOT_CLAIM',
    CLAIM = 'CLAIM',
    AVAILABLE = 'AVAILABLE',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    BURN = 'BURN',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    /**
     * Placeholder bonus waiting for its trigger (e.g. a future deposit).
     * Backend materializes these on registration so the player can see the
     * whole campaign upfront. Real amounts are filled in when the trigger
     * fires and the row flips to AVAILABLE.
     */
    LOCKED = 'LOCKED',
    /**
     * Free-spins bonus that the player activated. Spins are running at the
     * provider; balance stays 0 and wagering hasn't started yet. Flips to
     * ACTIVE when the Finish IPN arrives with the win amount.
     */
    SPINS_PENDING = 'SPINS_PENDING',
    /**
     * CASH bonus the player picked from a welcome OR-group before any
     * deposit happened. Siblings are already BURN. Amount/wagering are
     * still null because they depend on the upcoming first deposit —
     * the next deposit auto-activates this row (→ ACTIVE) on the server.
     * No player action besides topping up.
     */
    AWAITING_DEPOSIT = 'AWAITING_DEPOSIT',
}
